module.exports = __webpack_public_path__ + "img/receiptlogo.15c27d29.png";